/* global appData, FB, $ */

import events from '../events';
import framePage from '../framePage';
import sendMessageToParent from '../sendMessageToParent';

function facebookSignIn(scope) {
	if (!framePage.facebookAllowSubmit) {
		return false;
	}
	framePage.facebookAllowSubmit = false;
	const fbLoginOptions = {
		auth_type: 'rerequest', // use this when re-requesting a declined permission
		return_scopes: true, // include 'grantedScopes' field in 'authResponse'
		scope
	};

	FB.login(response => {
		if (response.authResponse) {
			$.ajax({
				type: 'POST',
				url: `${appData.appPath}/signin/frame/facebook`,
				data: {
					accessToken: response.authResponse.accessToken,
					facebookId: response.authResponse.userID
				},
				dataType: 'json',
				success(data) {
					switch (data.status) {
						case 'attCreated': {
							sendMessageToParent(events.SIGNIN_COMPLETE, { userId: data.userId });
							break;
						}
						default: {
							sendMessageToParent(events.SIGNIN_FACEBOOK_ERROR);
						}
					}
				},
				complete() {
					framePage.facebookAllowSubmit = true;
					$('#fbSignInBtn').removeClass('loading');
				},
				error({ status }) {
					if (status > 0) {
						sendMessageToParent(events.SIGNIN_SERVER_ERROR);
					} else {
						sendMessageToParent(events.SIGNIN_NETWORK_ERROR);
					}
				}
			});
		} else {
			framePage.facebookAllowSubmit = true;
			$('#fbSignInBtn').removeClass('loading');
		}
	}, fbLoginOptions);
}

export default facebookSignIn;
